<template lang="pug">
  .wechat-mp-button(ref="wechatMpButton")
    button(class="mp-button") {{btnText}}
    wx-open-launch-weapp(
      username="gh_cae4bd7d6f14"
      path="/pages/index/index"
      class="wx-open-weapp"
      ref="launchMpBtn"
      id="launch-btn"
    )
      script(type="text/wxtag-template")
        button.btn(style="width: 100000px; height: 100000px;")
</template>

<script>
import { configWechatSDK } from '@/utils/wechat';
import Vue from 'vue';

Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe'];

export default {
  components: {},
  props: {
    btnText: {
      type: String,
      default: '',
    },
    goToChannel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wxParams: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.wechatInit();
      const { query } = this.$route;
      if (Object.keys(query).length) {
        this.wxParams = query;
      }
    },
    wechatInit() {
      configWechatSDK().then(() => {
        const mpButton = this.$refs.launchMpBtn;
        if (mpButton) {
          const bizType = this.execBizType();
          if (bizType) {
            const mode = this.goToChannel ? '&mode=v2' : '';
            mpButton.setAttribute(
              'path',
              `/pages/index/index?q=${
                encodeURIComponent(`https://c3x.me?${bizType}=${this.wxParams[bizType]}${mode}&openId=${this.wxParams.openId}`)}`,
            );
          }
        }
      });
    },
    execBizType() {
      const p = this.wxParams || {};
      let bizType = null;
      if (p.n !== undefined) {
        bizType = 'n';
      } else if (p.e !== undefined) {
        bizType = 'e';
      } else if (p.u !== undefined) {
        bizType = 'u';
      } else if (p.c !== undefined) {
        bizType = 'c';
      }
      return bizType;
    },
  },
};
</script>

<style lang="less" scoped>
.login-page-container {
  background-image: url(https://m.hellobike.com/resource/LivingH5/LivingH5/kEJNj6bhzmx-Mps-vNkok.png);
  background-size: 100%;
  background-color: #effafe;
  background-repeat: no-repeat;
  padding-top: 1.2rem;
  height: 100vh;
  flex-direction: column;

  .wechat-mp-button {
    position: relative;
  }
}

.wx-open-weapp {
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0;
}
</style>
